export const BOARD_DIMENSIONS = { width: 9, height: 13 };

export const GOAL_PLACEMENT = { begin: 3, end: 5 };

export const MOVES = {
  LEFT: 0x1,
  LEFT_TOP: 0x2,
  TOP: 0x4,
  RIGHT_TOP: 0x8,
  RIGHT: 0x10,
  RIGHT_BOTTOM: 0x20,
  BOTTOM: 0x40,
  LEFT_BOTTOM: 0x80
};

export const MOVE_DIRECTIONS = {
  LEFT: [-1, 0],
  LEFT_TOP: [-1, -1],
  TOP: [0, -1],
  RIGHT_TOP: [1, -1],
  RIGHT: [1, 0],
  RIGHT_BOTTOM: [1, 1],
  BOTTOM: [0, 1],
  LEFT_BOTTOM: [-1, 1]
};

export const BALL_STATE = 0x0200;

export const EMPTY_STATE = 0x0;

export const EXPIRED_STATE = 0xff;
